export const getAction = () => {
  if (process.env.BUILD_TARGET === 'client') {
    const queries = new URLSearchParams(window.location.search);
    return queries.get('click') || '';
  } else {
    return '';
  }
};

export const removeHash = () => {
  if (/click=/.test(window.location.search)) {
    const queries = new URLSearchParams(window.location.search);
    queries.delete('click');
    let url = window.location.pathname;
    url += queries.toString() ? `?${queries.toString()}` : '';

    window.history.replaceState('', document.title, url);
  }
};
